/**
 *
 * Asynchronously loads the component for AccountPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
